import { createSelector } from 'reselect';

const selectStores = (state: any) => state.stores;


export const selectCurrentItem = createSelector([selectStores], (stores) => stores.current);

export const selectListItems = createSelector([selectStores], (stores) => stores.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectStores], (stores) => stores.create);

export const selectUpdatedItem = createSelector([selectStores], (stores) => stores.update);

export const selectReadItem = createSelector([selectStores], (stores) => stores.read);

export const selectDeletedItem = createSelector([selectStores], (stores) => stores.delete);

export const selectSearchedItems = createSelector([selectStores], (stores) => stores.search);

export const selectItemsCount = createSelector([selectStores], (stores) => stores.count);

export const selectItemsFilter = createSelector([selectStores], (stores) => stores.filter);